import { callFunction } from "./functions-client";

// Dispute resolution (Phase 2, dispute-resolution-platform spec).
export const DISPUTE_CONTEXTS = ["placement", "load", "job", "review", "other"] as const;
export const RESOLUTION_ACTIONS = ["refund", "clawback", "release", "adjust", "none"] as const;

export type DisputeStatus = "open" | "under_review" | "resolved" | "dismissed";

export interface Dispute {
  id: string;
  opener_account_id: string;
  respondent_account_id: string | null;
  context_type: string;
  context_id: string | null;
  claim: string;
  detail?: string | null;
  status: DisputeStatus;
  resolution?: string | null;
  resolution_action?: string | null;
  created_at: string;
  opener_email?: string | null;
}

export interface DisputeMessage {
  id: string;
  author_account_id: string;
  body: string;
  is_staff: boolean;
  created_at: string;
}

export interface DisputeEvidence {
  id: string;
  submitter_account_id: string;
  filename: string | null;
  created_at: string;
  url: string | null;
}

export const openDispute = (input: {
  context_type: string; context_id?: string; respondent_account_id?: string; claim: string; detail?: string;
}) => callFunction<{ dispute: Dispute }>("disputes/open", { body: input });

export const myDisputes = () =>
  callFunction<{ disputes: Dispute[] }>("disputes/mine", { method: "GET" });

export const getDispute = (id: string) =>
  callFunction<{ dispute: Dispute; messages: DisputeMessage[]; evidence: DisputeEvidence[] }>(`disputes/get?id=${encodeURIComponent(id)}`, { method: "GET" });

/** Register an evidence file on a dispute and get a signed upload URL. */
export const submitEvidence = (dispute_id: string, filename: string) =>
  callFunction<{ evidence_id: string; path: string; upload_url: string | null }>("disputes/evidence-submit", {
    body: { dispute_id, filename },
  });

export const postDisputeMessage = (dispute_id: string, body: string) =>
  callFunction<{ message: DisputeMessage }>("disputes/message", { body: { dispute_id, body } });

export const listDisputes = (status = "open") =>
  callFunction<{ disputes: Dispute[]; counts: Record<string, number> }>(`disputes/list?status=${encodeURIComponent(status)}`, { method: "GET" });

export const resolveDispute = (dispute_id: string, target: "resolved" | "dismissed", resolution?: string, resolution_action?: string) =>
  callFunction<{ dispute: Dispute; apply_hint: string | null }>("disputes/resolve", {
    body: { dispute_id, target, resolution, resolution_action },
  });
